import { combineReducers } from 'redux';
import menu from './menu/reducer';
import settings from './settings/reducer';
import authUser from './auth/reducer';
import document from './document/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  document
});

export default reducers;